import React from 'react';
import cn from 'classnames';
import { addMinutes } from 'date-fns';
// @ts-ignore date-fns-tz ships no type declarations
import { formatInTimeZone } from 'date-fns-tz';
import { DEFAULT_TIME_ZONE } from '@framework/timezone/constants';

import styles from './dateCell.module.scss';

const getDateFormat = ({
  withoutTime,
  withoutTimeZone,
}: {
  withoutTime: boolean,
  withoutTimeZone: boolean,
}): string => {
  let format = 'MMM dd, yyyy';

  if (!withoutTime) {
    format += ' hh:mm a';
  }

  if (!withoutTimeZone) {
    format += ' zzz';
  }

  return format;
};

interface IProps {
  date: string | number,
  withoutTime?: boolean,
  timeZone?: string,
  className?: string,
  timeZoneAbbr?: string,
  withoutFormat?: boolean,
  withoutAbbr?: boolean,
  isUtc?: boolean,
}

const DateCell = ({
  date,
  timeZone = DEFAULT_TIME_ZONE.timeZone,
  withoutTime,
  className,
  timeZoneAbbr,
  withoutFormat,
  withoutAbbr,
  isUtc,
}: IProps) => {
  const dateObj = new Date((!withoutFormat && typeof date === 'string') ? date.replace(/ /g, 'T') : date);

  const localDate = isUtc ? addMinutes(dateObj, -dateObj.getTimezoneOffset()) : dateObj;

  const formattedDate = formatInTimeZone(
    localDate,
    timeZone,
    getDateFormat({
      // @ts-ignore
      withoutTime,
      withoutTimeZone: withoutAbbr || !!timeZoneAbbr,
    }),
  );

  return (
    <div className={ cn(styles.date, className) }>
      { formattedDate } { timeZoneAbbr }
    </div>
  );
};

export default DateCell;
